import React, { useRef, useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import "./Empdocuments.css";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useYearContext } from "../../admin/components/YearContext";
import { toast } from "react-toastify";

function Empdocuments() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [activeTab, setActiveTab] = useState("client");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedComment, setSelectedComment] = useState("");
  const [username, setUsername] = useState("");
  const [clientDocuments, setClientDocuments] = useState([]);
  const fileInputRef = useRef(null);

  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      // No token, redirect to home
      // navigate("/");
    } else {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.email);

        // If the decoded role is not Client, redirect
        if (decoded.role !== "client") {
          // navigate("/");
        }
      } catch (error) {
        console.error("Invalid token");
        // navigate("/");
      }
    }
  }, []);

  // Handle switching tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const [uploadedby, setUploadedBy] = useState("");
  const handleOpenModal = (uploaded_by) => {
    if (uploaded_by === "Admin") {
      toast.warn("You can not reply to admin");
    } else {
      setIsModalOpen(true);
      setUploadedBy(uploaded_by);
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleDocumentTypeChange = (e) => {
    setSelectedDocumentType(e.target.value);
  };

  const handleCommentChange = (e) => {
    setSelectedComment(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if required fields are filled
    if (!selectedDocumentType || !selectedFile) {
      toast.warn("Please fill all required fields");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("username", username);
      formData.append("document_type", selectedDocumentType);
      formData.append("file", selectedFile);
      formData.append("add_comment", selectedComment);
      formData.append("uploaded_by", uploadedby);

      const response = await axios.post(
        " https://api.easytaxexperts.com/empuploadeddocs",
        formData
      );

      if (response.data.success) {
        toast.success("Document submitted successfully");
        window.location.reload();
        setSelectedFile(null);
        setSelectedDocumentType("");
        setSelectedComment("");
      } else {
        toast.error("Error submitting document");
      }
    } catch (error) {
      console.error("Error during document submission:", error);
    }
  };

  const handleCloseModal = () => {
    // Clear input values when closing the modal
    setSelectedFile(null);
    setSelectedDocumentType("");
    setSelectedComment("");
    setIsModalOpen(false);
  };

  const handleDownloaddoc = (filePath) => {
    // Replace backslashes with forward slashes in the filePath
    const formattedFilePath = filePath.replace(/\\/g, "/");

    // Construct the download URL based on the formatted filePath
    const downloadUrl = ` https://api.easytaxexperts.com/${formattedFilePath}`;

    // Fetch the file to ensure it's downloadable as a blob
    fetch(downloadUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch the file");
        }
        return response.blob(); // Get the file as a blob
      })
      .then((blob) => {
        // Create a temporary URL for the blob
        const blobUrl = URL.createObjectURL(blob);

        // Create a temporary link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = formattedFilePath.split("/").pop(); // Set the file name

        // Append the link to the body
        document.body.appendChild(link);

        // Programmatically click on the link to trigger the download
        link.click();

        // Clean up by revoking the blob URL and removing the link
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  useEffect(() => {
    fetchdocuments();
  }, [username]);

  const fetchdocuments = async () => {
    await axios
      .get(` https://api.easytaxexperts.com/empclientDocuments/${username}`)
      .then((response) => {
        if (response.data.success) {
          setClientDocuments(response.data.clientDocuments);
        } else {
          console.error(
            "Error fetching client documents:",
            response.data.message
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching client documents:", error);
      });
  };

  const filterDocuments = clientDocuments.filter((doc) => {
    const documentDate = doc.uploaded_on
      ? doc.uploaded_on.substring(0, 10)
      : "";
    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;
    const isYearMatch = documentDate >= startDate && documentDate <= endDate;
    return isYearMatch;
  });

  const reversedDocuments = filterDocuments.slice().reverse();
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [selectedClient,setselectedClient] = useState("");
  const [clientData, setClientData] = useState([]);

  const handleItemClick = (username) => {
    setselectedClient(username);
  };

  const fetchClientData = async() => {
   
    try{
      const response = await axios.get(`	 https://api.easytaxexperts.com/empinvoiceclients/${username}`);
      if(response.data.success){
             setClientData(response.data.clientsResult);
      }

    }catch(error){
      console.log(error);
    }
  }

  useEffect(() => {
fetchClientData();
  },[username])

  const handleOpenInvoiceModal = (selectedClient) => {
    
      setIsModalOpen(true);
      setUploadedBy(selectedClient);
    
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
          <div className="my-3 d-flex gap-2 justify-content-center">
              <div className="col-lg-4">
                <div className="dropdown">
                  <input
                    className="form-control dropdown-toggle"
                    data-bs-toggle="dropdown"
                    name="clientname"
                    placeholder="Select Client"
                    value={selectedClient}
                    onChange={(e) => setselectedClient(e.target.value)}
                  />

                  <ul className="dropdown-menu employeeul" >
                    {clientData
                      .filter((client) =>
                        client.client_name
                          .toLowerCase()
                          .includes(selectedClient.toLowerCase())
                      )
                      .map((client) => (
                        <li
                          className="dropdown-item"
                          key={client.client_name}
                          onClick={() => handleItemClick(client.client_name)}
                        >
                          {client.client_name}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                // onClick={fetchClients}
                onClick={() =>
                  handleOpenInvoiceModal(selectedClient)
                }
              >
                Upload
              </button>
            </div>
            <div
              className="table-container"
              style={{
                height: "calc(97vh - 150px)", // Adjust the 150px based on your header/pagination height

                border: "1px solid #ccc",
              }}
            >
              <div className="table-responsive tablediv">
                <table
                  className="table table-hover table-bordered"
                  style={{
                    fontSize: "12px", // Smaller font size
                    lineHeight: "1.2", // Reduce line height for compact view
                  }}
                >
                  <thead className="table-primary">
                    <tr>
                      <th style={{ padding: "5px" }}>S.No</th>
                      <th style={{ padding: "5px" }}>Document Type</th>
                      <th style={{ padding: "5px" }}>UploadedOn</th>
                      <th style={{ padding: "5px" }}>Uploaded By</th>
                      <th style={{ padding: "5px" }}>Send To</th>
                      <th style={{ padding: "5px" }}>Comments</th>
                      <th style={{ padding: "5px" }}>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((document, index) => (
                      <tr key={index}>
                        <td style={{ padding: "5px" }}>
                          {filterDocuments.length -
                            ((currentPage - 1) * recordsPerPage + index)}
                        </td>
                        <td>{document.type}</td>
                        <td>{document.uploaded_on}</td>
                        <td>{document.uploaded_by}</td>
                        <td>{document.send_to}</td>
                        <td>{document.comments}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-primary btn-sm"
                              title="Download PDF"
                              onClick={() => {
                                handleDownloaddoc(document.filePath.trim());
                              }}
                            >
                              Download
                            </button>
                            <div>
                              <div>
                                <button
                                  className="btn btn-secondary btn-sm"
                                  type="button"
                                  onClick={() =>
                                    handleOpenModal(document.uploaded_by)
                                  }
                                >
                                  UploadDocument
                                </button>
                              </div>
                            </div>

                            {isModalOpen && (
                              <div
                                className="modal fade show"
                                style={{
                                  display: "block",
                                  backgroundColor: "rgba(0,0,0,0.5)",
                                }}
                              >
                                <div className="modal-dialog">
                                  <div className="modal-content">
                                    <div className="modal-header d-flex justify-content-between">
                                      <h5
                                        className="modal-title"
                                        id="exampleModalLabel"
                                      >
                                        Document
                                      </h5>
                                      <button
                                        type="button"
                                        className="close"
                                        onClick={handleCloseModal}
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                    <div className="modal-body">
                                      <div className="form-group">
                                        <label htmlFor="dropdownInput">
                                          Document Type:
                                        </label>
                                        <select
                                          className="form-control"
                                          id="dropdownInput"
                                          name="dropdownInput"
                                          onChange={handleDocumentTypeChange}
                                          value={selectedDocumentType}
                                        >
                                          <option value="" disabled>
                                            Select Document Type
                                          </option>
                                          <optgroup label="Income Forms" className="red-label">
                        <option value="W-2 - Wage and salary income">W-2 - Wage and salary income.</option>
                        <option value="W-2C - Corrected Wage and Tax Statement">W-2C - Corrected Wage and Tax Statement.</option>
                        <option value="W2-G - Certain Gambling Winnings">
                        W2-G - Certain Gambling Winnings.
                        </option>
                        <option value="1042-S - Foreign person's U.S. source income">1042-S - Foreign person's U.S. source income.</option>
                       
                      </optgroup>
                      <optgroup label="Foreign Wage Statement" className="red-label">
                        <option value="K-1  - Income from partnerships, S corporations, estates, or trusts">
                        K-1  - Income from partnerships, S corporations, estates, or trusts.
                        </option>
                        <option value="1099-INT - Interest income">
                        1099-INT - Interest income.
                        </option>
                        <option value="1099-DIV - Dividend income">
                        1099-DIV - Dividend income.
                        </option>
                        <option value="1099-B - Proceeds from Broker and Barter Exchange Transactions">
                        1099-B - Proceeds from Broker and Barter Exchange Transactions.
                        </option>
                        <option value="1099-NEC - Non-employee compensation">
                        1099-NEC - Non-employee compensation.
                        </option>
                        <option value="1099-MISC -Miscellaneous Income">
                        1099-MISC -Miscellaneous Income.
                        </option>
                        <option value="1099-G - Certain Government Payments">
                        1099-G - Certain Government Payments.
                        </option>
                        <option value="1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc">
                        1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc.
                        </option>
                        <option value="1099-K -Payment Card and Third-Party Network Transactions">
                        1099-K -Payment Card and Third-Party Network Transactions.
                        </option>
                        <option value="1095-A - Health Insurance Marketplace Statement">
                        1095-A - Health Insurance Marketplace Statement.
                        </option>
                        <option value="1099-S -Proceeds From Real Estate Transactions">
                        1099-S -Proceeds From Real Estate Transactions.
                        </option>
                        <option value="1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs">
                        1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs.
                        </option>
                        <option value="1099-C -Cancellation of Debt (discharged debt may be considered taxable income)">
                        1099-C -Cancellation of Debt (discharged debt may be considered taxable income).
                        </option>
                        <option value="1099-LTC - Long-Term Care and Accelerated Death Benefits">
                        1099-LTC - Long-Term Care and Accelerated Death Benefits.
                        </option>
                        <option value="1099-RRB - Railroad Retirement Benefits">
                        1099-RRB - Railroad Retirement Benefits.
                        </option>
                        <option value="1099-Q - Payments from Qualified Education Programs">
                        1099-Q - Payments from Qualified Education Programs.
                        </option>
                      </optgroup>
                      <optgroup label="Expense Forms" className="red-label">
                        <option value="1098 - Mortgage interest payments">1098 - Mortgage interest payments.</option>
                        <option value="1098-T -Tuition Statement">1098-T -Tuition Statement</option>
                        <option value="1098-E -Student Loan Interest Statement">1098-E -Student Loan Interest Statement</option>
                        <option value="1098-F -Fines, Penalties, and Other Amounts">1098-F -Fines, Penalties, and Other Amounts</option>
                        <option value="1098-C -Contributions of Motor Vehicles, Boats, and Airplanes">1098-C -Contributions of Motor Vehicles, Boats, and Airplanes</option>
                        <option value="Foreign Home Interest Certificate/Statement From Bank">Foreign Home Interest Certificate/Statement From Bank</option>
                       
                      </optgroup>
                      <optgroup label="Others" className="red-label">
                        <option value="Tax Organizer">Tax Organizer</option>
                        <option value="Prior Year Tax Return Copy">Prior Year Tax Return Copy</option>
                        <option value="Tax Summary">Tax Summary</option>
                        <option value="Client Copy">Client Copy</option>
                        <option value="IDS">IDS</option>
                        <option value="Final Draft">Final Draft</option>
                        <option value="Paper Filing Instructions">Paper Filing Instructions</option>
                        <option value="Other Documents">Other Documents</option>                       
                      </optgroup>
                                        </select>
                                      </div>
                                      <div className="form-group mt-2">
                                        <label htmlFor="fileInput">
                                          Upload File:
                                        </label>
                                        <input
                                          ref={fileInputRef}
                                          type="file"
                                          className="form-control-file"
                                          id="fileInput"
                                          name="fileInput"
                                          onChange={handleFileChange}
                                        />
                                      </div>
                                      <div className="form-group mt-2">
                                        <label htmlFor="commentInput">
                                          Add Comment:
                                        </label>
                                        <textarea
                                          className="form-control"
                                          id="commentInput"
                                          name="commentInput"
                                          rows="3"
                                          onChange={handleCommentChange}
                                          value={selectedComment}
                                        ></textarea>
                                      </div>
                                    </div>
                                    <div className="modal-footer">
                                      <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseModal}
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={(e) => handleSubmit(e)}
                                      >
                                        Save changes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <nav className="mt-2">
              <ul
                className="pagination"
                style={{
                  fontSize: "10px", // Reduce font size
                  padding: "0", // Remove unnecessary padding
                }}
              >
                <li className="page-item">
                  <a
                    href="#"
                    className="page-link"
                    onClick={prePage}
                    style={{
                      padding: "2px 5px", // Adjust padding for smaller height
                      height: "auto", // Allow height to adjust with padding
                      fontSize: "12px",
                    }}
                  >
                    Prev
                  </a>
                </li>
                {numbers.map((n, i) => {
                  return (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCpage(n)}
                        style={{
                          padding: "2px 5px", // Reduce padding
                          height: "auto", // Consistent height
                          fontSize: "12px",
                        }}
                      >
                        {n}
                      </a>
                    </li>
                  );
                })}
                <li className="page-item">
                  <a
                    href="#"
                    className="page-link"
                    onClick={nextPage}
                    style={{
                      padding: "2px 5px", // Same padding as above
                      height: "auto", // Adjust height
                      fontSize: "12px",
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empdocuments;
